<ul class="media-list media-list-divider mr-2">
    <li *ngFor="let d of topDepartments" class="media align-items-center">
      <div class="media-body d-flex align-items-center">
        <div class="flex-1">
          <div class="media-heading">{{ d.name }}</div>
          <small class="text-muted">{{ d.performance }}</small>
        </div>
        <div>
          <span class="badge badge-primary badge-pill">{{ d.count }}</span>
        </div>
      </div>
    </li>
  </ul>
